import { render } from "./CreateVolume.vue?vue&type=template&id=257307f3&scoped=true"
import script from "./CreateVolume.vue?vue&type=script&lang=js"
export * from "./CreateVolume.vue?vue&type=script&lang=js"

import "./CreateVolume.vue?vue&type=style&index=0&id=257307f3&lang=scss&scoped=true"

import exportComponent from "/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-257307f3"]])

export default __exports__